import { useEffect } from "react";
import { C } from "../../lib/tokens.js";

// Shared "fixed backdrop + centered card" shell used by every confirm/edit/lightbox
// dialog in the app — backdrop click, Escape key, and the card chrome (background,
// radius, shadow) all live here once instead of being hand-rolled per modal.
export function Modal({ onClose, children, width = 480, maxHeight, backdropOpacity = 0.35, cardStyle }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      <div
        onClick={(e) => { e.stopPropagation(); onClose?.(); }}
        style={{ position: "fixed", inset: 0, background: `rgba(0,0,0,${backdropOpacity})`, zIndex: 200 }}
      />
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 201,
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 16, pointerEvents: "none",
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            pointerEvents: "auto", position: "relative",
            background: C.tin, borderRadius: 8, boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            width, maxWidth: "calc(100vw - 32px)",
            ...(maxHeight ? { maxHeight, overflowY: "auto" } : {}),
            padding: 24, display: "flex", flexDirection: "column", gap: 16,
            ...cardStyle,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}
